import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '../assets/page-image/dqly/banner.jpg';
const _hoisted_1 = {
  class: "dqly-list-wrapper"
};
const _hoisted_2 = {
  class: "dqly-list-page"
};
const _hoisted_3 = {
  class: "section"
};
const _hoisted_4 = {
  key: 0,
  class: "loading"
};
const _hoisted_5 = {
  key: 1,
  class: "news-list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "news-content"
};
const _hoisted_8 = {
  class: "news-title"
};
const _hoisted_9 = {
  class: "news-date"
};
const _hoisted_10 = {
  class: "pagination"
};
import { ref, onMounted, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { getColumnPage } from '@/api/party';
export default /*@__PURE__*/_defineComponent({
  __name: 'DqlyList',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const currentPage = ref(1);
    const pageSize = ref(20);
    const total = ref(0);
    const newsList = ref([]);
    const loading = ref(false);
    const categoryId = ref(50); // 默认通知公告
    const categoryTitle = ref('通知公告');
    // 分类映射
    const categoryMap = {
      48: '党建动态',
      49: '规章制度',
      50: '通知公告',
      51: '创新文化'
    };
    // 获取列表数据
    const getNewsList = async () => {
      loading.value = true;
      try {
        const res = await getColumnPage({
          categoryId: categoryId.value,
          pageNum: currentPage.value,
          pageSize: pageSize.value
        });
        // console.log('接口返回数据：', res);
        if (res.data) {
          newsList.value = res.data;
          total.value = res.total || 0;
        }
      } catch (error) {
        console.error('获取列表失败:', error);
      } finally {
        loading.value = false;
      }
    };
    // 格式化日期
    const formatDate = dateStr => {
      if (!dateStr) return '';
      // 处理格式：2026-01-30 00:00:00
      return dateStr.split(' ')[0];
    };
    // 跳转到详情页
    const goToDetail = id => {
      router.push(`/dqlyDetail/${id}`);
    };
    // 初始化分类信息
    const initCategory = () => {
      const queryCategoryId = route.query.categoryId;
      if (queryCategoryId) {
        const id = Number(queryCategoryId);
        if (categoryMap[id]) {
          categoryId.value = id;
          categoryTitle.value = categoryMap[id];
        }
      }
    };
    // 监听分页变化
    watch(currentPage, () => {
      getNewsList();
    });
    // 页面加载时获取数据
    onMounted(() => {
      initCategory();
      getNewsList();
    });
    return (_ctx, _cache) => {
      const _component_BlueSectionTitle = _resolveComponent("BlueSectionTitle");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "banner-wrapper"
      }, [_createElementVNode("div", {
        class: "banner-container"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "党群园地",
        class: "banner"
      })])], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_BlueSectionTitle, {
        title: categoryTitle.value,
        showMore: false,
        class: "blue-title"
      }, null, 8, ["title"]), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, "加载中...")) : (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "news-item",
          key: item.id,
          onClick: $event => goToDetail(item.id)
        }, [_createElementVNode("div", _hoisted_7, [_cache[1] || (_cache[1] = _createElementVNode("span", {
          class: "dot"
        }, null, -1)), _createElementVNode("span", _hoisted_8, _toDisplayString(item.title), 1)]), _createElementVNode("div", _hoisted_9, _toDisplayString(formatDate(item.publishTime)), 1)], 8, _hoisted_6);
      }), 128))])), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_pagination, {
        background: "",
        layout: "total, prev, pager, next",
        total: total.value,
        "page-size": pageSize.value,
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => currentPage.value = $event)
      }, null, 8, ["total", "page-size", "current-page"])])])]), _createVNode(_component_Footer)]);
    };
  }
});